import React from 'react';
import { Grid, List, Divider, Drawer, ListSubheader } from '@material-ui/core';
import DevCreditPull from 'app/components/DevTool/DevCreditPull';
import DevTestBorrowers from 'app/components/DevTool/DevTestBorrowers';
import { DevCache } from 'app/components/DevTool/DevCache';
import { DevFormRoutes } from 'app/components/DevTool/DevFormRoutes';
import DevGlobalOpts from 'app/components/DevTool/DevGlobalOpts';
import DevTestPrequalCalc from 'app/components/DevTool/DevTestPrequalCalc';
import { devToolLog } from 'app/actions';
import DevPropertyInfo from 'app/components/DevTool/DevPropertyInfo';
import DevFinicity from 'app/components/DevTool/DevFinicity';
import { isLocalhost } from '../../api/helpers';

/**
 * Wrapper for our custom development tools.
 * Press `Ctrl+Z` to show/hide
 */
export default class DevToolWrapper extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };

    this.toggleDrawer = this.toggleDrawer.bind(this);
    this.handleKeypress = this.handleKeypress.bind(this);
    devToolLog('Devtool loaded. Press Ctrl+Z to open/close');
  }

  toggleDrawer = (open) => () => {
    this.setState({
      open,
    });
  };

  handleKeypress(event: KeyboardEvent) {
    if (event.keyCode === 90 && event.ctrlKey) {
      this.setState({
        open: !this.state.open,
      });
    }
    else if(validateSeleniumSendKeyEvent(event)) {
      this.setState({
        open: !this.state.open,
      });
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeypress);
  }

  componentDidCatch() {
    devToolLog(
      'DevToolWrapper threw an uncaught exception, this is a known issue and is related to our current material-ui version',
    );
  }

  render() {
    const tools = (
      <div style={{ width: 'auto' }}>
        <List subheader={<ListSubheader>Menu</ListSubheader>}>
          <DevFormRoutes/>
          <DevTestBorrowers/>
          <DevCreditPull />
          <DevFinicity />
          <DevPropertyInfo />
        </List>
        <Divider />
        <List subheader={<ListSubheader>Auto-Prequal</ListSubheader>}>
          <DevTestPrequalCalc />
        </List>
        <Divider />
        <List subheader={<ListSubheader>Global Options</ListSubheader>}>
          <DevGlobalOpts />
        </List>
        <Divider />
        <List subheader={<ListSubheader>Cache</ListSubheader>}>
          <DevCache />
        </List>
      </div>
    );
    return process.env.REACT_APP_IS_STAGING_OR_DEV === 'true' ? (
      <Grid container>
        <Drawer
          anchor="left"
          open={this.state.open}
          onClose={this.toggleDrawer(false)}
        >
          <div
            tabIndex={0}
            role="button"
          >
            {tools}
          </div>
        </Drawer>
        <Divider />
      </Grid>
    ) : null;
  }
}

const validateSeleniumSendKeyEvent = (event) => {
  return (
    isLocalhost &&
    (
      (event.target.innerText.toLowerCase().includes('demo') && event.target.innerText.toLowerCase().includes('credit')) ||
      event.target.innerText === 'Step 1 of 5: Personal Information'// Express #102
    )
    && !event.key && !event.isTrusted
  );
};
